import { useScript } from '@/libs/hooks/src/lib/useScript';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const PAY_JS_URL = import.meta.env.VITE_PAY_JS_URL as string;

export default function PayJsManager() {
  const location = useLocation();

  const shouldLoadPayJs = useMemo(() => {
    const path = location.pathname || '';

    return (
      path.startsWith('/billing') ||
      path.startsWith('/patients') ||
      path.startsWith('/settings/subscription') ||
      path.includes('transaction')
    );
  }, [location.pathname]);

  const scriptStatus = useScript(shouldLoadPayJs ? PAY_JS_URL : null, {
    removeOnUnmount: false,
  });

  useEffect(() => {
    if (scriptStatus === 'ready') {
      (window as any).usaepay.PaymentCard.prototype.addEventListener = function (
        eventType: any,
        response: any
      ) {
        function messageListener(event: any) {
          const paymentCardiFrame = document.getElementById('paymentCardIFrame');

          if (paymentCardiFrame && event.source === (paymentCardiFrame as any).contentWindow) {
            if (typeof event.data === 'string') {
              const msg = event.data.split('::');

              if (msg[0] === eventType) {
                response(msg[1]);
              }
            }
          }
        }

        window.addEventListener('message', messageListener);

        return function cleanup() {
          window.removeEventListener('message', messageListener);
        };
      };
    } else if (scriptStatus === 'error') {
      console.error('Failed to load useepay script.');
    }
  }, [scriptStatus]);

  return null;
}
